.flag(class=type)
  if asset
    img(src=asset)
  if !asset
    each color in colors
      span(style=`background-color: ${color}`)
